
import { defineComponent, PropType } from 'vue'
import { iTimespan, iCategory } from './Timespan'
import Dropdown from 'primevue/dropdown'
import timespanDescriptor from './TimespanDescriptor.json'
import Card from 'primevue/card'

export default defineComponent({
    name: 'timespan-form',
    components: { Dropdown, Card },
    props: { propTimespan: { type: Object as PropType<iTimespan | null> }, categories: { type: Array as PropType<iCategory[]> } },
    emits: ['touched'],
    data() {
        return {
            timespanDescriptor,
            timespan: null as iTimespan | null
        }
    },
    watch: {
        propTimespan() {
            this.loadTimespan()
        }
    },
    created() {
        this.loadTimespan()
    },
    methods: {
        loadTimespan() {
            this.timespan = this.propTimespan as iTimespan
        },
        onTypeChange() {
            if (this.timespan) {
                this.$emit('touched')
                this.timespan.definition = []
            }
        }
    }
})
